import React from "react";
import PropTypes from "prop-types";
import "./TransactionProcessing.style.scss";
import {_t} from "../../../../../../utils/I18nUtils";

const TransactionProcessing = ({ vm, style})=>{
    return <div className="TransactionProcessing" style={style}>
        <h2 className="text-center">{_t(`views.addFundsView.nuvei.transactionProcessing.title`)}</h2>
        <br/>
        <p className="text-center">{_t(`views.addFundsView.nuvei.transactionProcessing.content`)}</p>
    </div>
};

TransactionProcessing.propTypes = {
    vm: PropTypes.object,
};

export default TransactionProcessing;